/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'base-school': {
    width: 16,
    height: 15.999,
    viewBox: '0 0 16 15.999',
    data: '<path pid="0" d="M14.194 15.999h-2.235l-1.118-1.88 1.118-1.88h2.236l1.118 1.879-1.118 1.881zm-2.037-1.869a.93.93 0 00.919.918h.033a.96.96 0 00.815-.45.894.894 0 000-.936.96.96 0 00-.817-.451h-.031a.93.93 0 00-.918.919zm-2 .307H5.136a2.873 2.873 0 01-2.91-2.812V7.564a.386.386 0 01.172-.319.417.417 0 01.228-.069.421.421 0 01.141.025l4.708 1.717a1.241 1.241 0 00.491.1 1.21 1.21 0 00.475-.095l4.792-1.755a.412.412 0 01.142-.025.408.408 0 01.227.068.388.388 0 01.173.319v3.621h-1.487a1.326 1.326 0 00-1.162.812l-.79 1.659a1.923 1.923 0 00-.179.812zM7.168 7.803l-6.4-2.774a1.148 1.148 0 01-.77-1.051 1.138 1.138 0 01.759-1.046L7.091.162a2.624 2.624 0 011.815 0l6.323 2.766a1.143 1.143 0 01.77 1.05 1.139 1.139 0 01-.76 1.047l-6.332 2.77a1.869 1.869 0 01-.851.167h-.035a2.389 2.389 0 01-.855-.159z" _fill="#212121"/>'
  }
})
